import React from 'react';

import Box from 'carbon-react/lib/components/box';

import { WizardRequiredFieldInfo } from '@futrli/ui-components/components/sidebar/wizard/wizard-required-field-info/wizard-required-field-info';

import { UserDetailsFields } from './user-details-fields';
import { UserFormController } from '../types';
import { UserOrganisationSelector } from './user-organisation-selector';
import { UserRoleSelect } from './user-role-select';

interface UserFormProps {
  disableIdentityFields?: boolean;
  disableOrganisations?: boolean;
  disableRole?: boolean;
  form: UserFormController;
}

export const UserForm = ({
  disableIdentityFields = false,
  disableOrganisations = false,
  disableRole = false,
  form
}: UserFormProps) => (
  <Box>
    <WizardRequiredFieldInfo />
    <UserDetailsFields disableIdentityFields={disableIdentityFields} form={form} />
    <UserRoleSelect disableRole={disableRole} form={form} />
    <UserOrganisationSelector disabled={disableOrganisations} form={form} />
  </Box>
);
